import { BaseControl, RadioControl as WPRadioControl } from '@wordpress/components';

const RadioControl = ({ field, value, ...rest }) => {
    return (
        <BaseControl __nextHasNoMarginBottom>
            <WPRadioControl
                label={field.label}
                selected={value}
                options={field.options || []}
                {...rest}
            />
        </BaseControl>
    );
};

export default RadioControl;